import React from 'react';

import {getEventById, removeEventByIdFailure} from 'src/openapi/apis/EventControllerApi';
import {removeTriggerAttachmentByName} from 'src/openapi/apis/TriggerAttachmentControllerApi';
import {TriggerAttachment} from 'src/openapi/models/TriggerAttachment';
import {useAppDispatch} from 'src/store';

import {FlatButton} from '@pb/kit-component-button';
import {Group, Item} from '@pb/kit-component-group';
import {Icons} from '@pb/kit-component-icon';
import {OnCloseNote, Status, usePushNotification} from '@pb/kit-component-push-notification';

type Props = {
    attachment: TriggerAttachment,
    eventId: number,
    onClose: OnCloseNote,
};

const ERROR_AUTO_HIDE_TIMEOUT = 10000;
const ERROR_MESSAGE = 'Failed to delete attachment. Check whether there is an open change request.';

export const PushNotificationRemoveTriggerAttachment = ({attachment, eventId, onClose}: Props) => {
    const dispatch = useAppDispatch();
    const {onCreateNote} = usePushNotification();

    const onClick = async () => {
        const response =
            await dispatch(removeTriggerAttachmentByName({name: attachment.name, eventId}));

        if (response.payload.success) {
            onClose(`${attachment.id}`).then(() => {
                dispatch(getEventById({id: eventId}));
            });
        }

        if (response.payload.error) {
            onCreateNote({
                id: removeEventByIdFailure.type,
                status: Status.ERROR,
                message: ERROR_MESSAGE,
                buttonProps: {icon: Icons.CLOSE},
                autoHideTimeout: ERROR_AUTO_HIDE_TIMEOUT,
            });
        }
    };

    return (
        <Group justify="space-between" style={{maxWidth: '90%'}}>
            <Group gap="none" style={{maxWidth: '90%'}}>
                <Group gap="xs" style={{minWidth: '70%'}}>
                    <Item>Delete attachment?</Item>
                </Group>
            </Group>
            <FlatButton onClick={onClick}>Delete</FlatButton>
        </Group>
    );
};
